import { siteInfo } from '@/mocks/chiguaData';

export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20abstract%20rendering%20with%20warm%20coral%20and%20soft%20amber%20gradient%20tones%2C%20flowing%20organic%20shapes%20like%20speech%20bubbles%20and%20sound%20waves%2C%20modern%20social%20media%20concept%20art%2C%20clean%20minimal%20design%2C%20soft%20glow%20effects%2C%20editorial%20background%2C%20no%20text&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="91在线吃瓜背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-sm font-medium mb-5">
              {siteInfo.tagline}
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 font-heading">
              {siteInfo.name}
              <br />
              <span className="text-primary-300">每日新鲜瓜 · 一网打尽</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-6">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {siteInfo.stats.map((stat, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-bold text-white font-heading">
                    {stat.value}
                  </span>
                  <span className="text-sm text-white/70">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleNavClick(e, '#updates')}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-lg"></i>
                看最新瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-base border border-white/25 hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                今日热门瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20vibrant%20colorful%20abstract%20social%20media%20feed%20with%20floating%20cards%20and%20speech%20bubbles%20in%20warm%20coral%20pink%20and%20amber%20tones%2C%20modern%20editorial%20design%2C%20layered%20paper%20cut%20style%2C%20clean%20composition%2C%20entertainment%20news%20concept&width=800&height=700&seq=hero-visual-2026&orientation=portrait"
                alt="91在线吃瓜主视觉 - 最新吃瓜内容聚合"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}